import React from "react";
import {RadioButtonGroupItem as PatronRadioButtonGroupItem} from "@unibuddy/patron";

export const RadioButtonGroupItem = (props) => {
    return <PatronRadioButtonGroupItem {...props} />;
};
